interface PageHeaderProps {
  title?: string
  description?: string
  mobileTitle?: string
  mobileDescription?: string
}
export default function PageHeader({
  title,
  description,
  mobileTitle,
  mobileDescription,
}: PageHeaderProps) {
  return (
    <div className='py-3'>
      <h1 className='font-bold text-2xl hidden md:flex'>{title}</h1>
      <h1 className='font-normal text-2xl block md:hidden '>{mobileTitle}</h1>
      <p className='text-[#6B7280] text-sm hidden md:flex'>{description}</p>
      <p className='text-[#6B7280] text-sm md:hidden'>{mobileDescription}</p>
    </div>
  )
}
